import React from "react";
import { TeamModel } from "../../features/team/TeamTypes";

import { useNavigate  } from 'react-router-dom';
type Props = {
    team: TeamModel;
};

const TeamItem = ({ team }: Props) => {
    const navigate = useNavigate ();

    const handleClick = () => {
        navigate(`/teams/${team.slug}`);
    };

    return (
        <div
            key={team.id}
            className="text-center d-flex flex-column align-items-center mx-2 col-md-3 m-3 "
            onClick={handleClick}
            style={{ cursor: "pointer" }}
        >
            <img
                src={team.team_image}
                className="rounded-circle mb-3"
                style={{ width: "150px" }}
                alt="Avatar"
            />
            <h2 className="mb-2">
                <strong>{team.name}</strong>
            </h2>
        </div>
    );
};

export default TeamItem;
